import { TaxReportComponent } from './tax-report.component';
export var taxReportRoutes = [
    {
        path: 'taxReport',
        component: TaxReportComponent,
        data: {
            'expectedRoles': ['Accountant', 'Accountant Admin', 'IT']
        },
    },
];
var TaxReportRoutingModule = (function () {
    function TaxReportRoutingModule() {
    }
    return TaxReportRoutingModule;
}());
export { TaxReportRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report-routing.module.ts.pre-build-optimizer.js